import { Box } from "@mui/material"
import { BulkDeleteDialog } from "@/components/ui/bulk-delete-dialog"

interface Reseller {
  id: string | number
  name: string
  code?: string
  city?: string
  state?: string
  country?: string
}

interface BulkDeleteResellerModalProps {
  isOpen: boolean
  onClose: () => void
  selectedResellers: Reseller[]
  onConfirmDelete?: (resellerIds: string[]) => Promise<void>
}

export function BulkDeleteResellerModal({
  isOpen,
  onClose,
  selectedResellers,
  onConfirmDelete,
}: BulkDeleteResellerModalProps) {
  return (
    <BulkDeleteDialog
      isOpen={isOpen}
      onClose={onClose}
      items={selectedResellers}
      entityLabel={{ singular: "Reseller", plural: "Resellers" }}
      cascadingWarning="This will permanently remove all selected resellers from the system. This will remove the reseller association from all customers."
      renderItem={(r) => (
        <>
          {r.name}
          {r.code && <Box component="span" sx={{ color: "error.main" }}> (Code: {r.code})</Box>}
        </>
      )}
      onConfirm={async (ids) => {
        if (onConfirmDelete) await onConfirmDelete(ids)
      }}
    />
  )
}
